<template>
    <div>
      <Header />
      <div class="d-flex justify-center mt-12" style="height: 100%">
          <div class="mt-12 pt-12 sansation_title">Oops, this page does not exist!</div>
      </div>
    </div>
</template>

<script>

  import Header from './Header'

  export default {
    name: '404',
    components: {
      Header
    },

    created () {
        document.title = 'SRG myCompass: Page Not Found'
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/404.vue